<template>
    <div class="">
        <Wait_Skeleton v-if="!IsWait" />

        <Card class="h-100" v-if="IsWait">
            <template #title> </template>
            <template #content>

                <div class="grid flex justify-content-center flex-wrap">
                    <!-- 1. Kolon -->
                    <div class="col-2">
                        <Card style="width: 100%; overflow: hidden">
                            <template #header>
                                <div class="grid">
                                    <div class="col-12">
                                        <img alt="user" class="w-full" src="@/assets/genel/blank_user.jpg" />
                                    </div>
                                    <div class="col-12 flex justify-content-center flex-wrap">
                                        <Button label="Resim Değiştir" severity="info" variant="text" raised @click="this.ResimDegistir()" />
                                    </div>
                                </div>
                            </template>
                            <template #title>
                                <div class="flex justify-content-center flex-wrap">
                                    Coşkun Küçük
                                </div>
                            </template>
                            <template #subtitle>
                                <div class="flex justify-content-center flex-wrap">
                                    {{ this.KullaniciProfilBilgi.RolAd }}
                                </div>
                            </template>
                        </Card>
                    </div>
                    <!-- 2. Kolon -->
                    <div class="col-10">
                        <div class="grid">
                            <div class="col-4">
                                <label for="Ad" class="font-bold block">Ad</label>
                                <InputText id="Ad" type="text" v-model="this.KullaniciProfilBilgi.Ad" class="text-base text-color w-full"
                                    disabled />
                            </div>
                            <div class="col-4">
                                <label for="Soyad" class="font-bold block">Soyad</label>
                                <InputText id="Soyad" type="text" v-model="this.KullaniciProfilBilgi.Soyad" class="text-base text-color w-full"
                                    disabled />
                            </div>
                            <div class="col-4">
                                <label for="OlusturmaTarih" class="font-bold block">OlusturmaTarih</label>
                                <InputText id="OlusturmaTarih" type="text" v-model="this.KullaniciProfilBilgi.OlusturmaTarih" class="text-base text-color w-full"
                                    disabled />
                            </div>
                            <div class="col-4">
                                <label for="Mail" class="font-bold block">Mail</label>
                                <InputText id="Mail" type="text" v-model="this.KullaniciProfilBilgi.Mail" class="text-base text-color w-full"
                                    disabled />
                            </div>
                        </div>

                    </div>
                    <Divider />
                    <div class="col-12 flex justify-content-end flex-wrap">
                        <IslemYapiliyor v-if="IslemYapiliyor" />
                        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small"
                            severity="success" @click="this.handleClick()" autofocus :disabled="IslemYapiliyor"
                            v-if="!IslemYapiliyor" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
    data() {
        return {
            IslemYapiliyor: false,
            IsWait: false,

            KullaniciProfilBilgi : [],


            // Validation Elements
            // Valid: {
            //     Ad: false,

            // }
        }
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            // this.IslemYapiliyor = true;
            this.$toast.add({
                severity: "info",
                summary: "Pek Yakında",
                life: 3000,
            });
        },
        ResimDegistir(){
            this.$toast.add({
                severity: "info",
                summary: "Pek Yakında",
                life: 3000,
            });

        },
        _GetKullaniciProfilBilgi() {
            GlobalServis.GlobalServis("GET", "GetKullaniciProfilBilgi", "").then((res) => {
                if (res.status == 200) {
                    this.KullaniciProfilBilgi = res.data[0];                   
                    
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            })
        },
        _ResetForm() {

        },
        _FormCheck() {
            let Check = false;
            // if (this.Ad === "") {
            //     this.Valid.Ad = true;
            //     this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Ad girin", life: 3000, });
            //     Check = true;
            //     return Check;
            // } else { this.Valid.Ad = false; Check = false; }
            return Check;
        },

    },
    created() {
        this._GetKullaniciProfilBilgi();
        this.IsWait = true;
    },
    components: {
    },

}
</script>